export default "__VITE_ASSET__uIX2zyJV__"